export default __webpack_public_path__ + "static/media/order-completed.e98283cf.svg";